// DebugTracking.js
'use strict';
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import DebugTracking from '../component/DebugTracking.jsx';

import getOperationData from '../selector/getOperationData.js';

const mapStateToProps = state => {
  return {
    isElementIdDebugTrackingEnabled: getOperationData(
      state,
      ['debug', 'tracking'],
      'elementId'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateDebugTracking: ({ key, value }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['debug', 'tracking'],
          data: {
            [key]: value,
          },
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DebugTracking);
